import { PayloadAction } from '@reduxjs/toolkit'
import { User, UserCredentials, UserSliceState, UserSubscription } from 'src/core/models'
import { initialState } from './state'

const reducers = {
  setUser: (state: UserSliceState, action: PayloadAction<User>) => {
    state.user = action.payload
  },
  setLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.loading = action.payload
  },
  setWidgetUsers: (state: UserSliceState, action: PayloadAction<object[]>) => {
    state.widgetUsers = action.payload
  },
  setErrorMessage: (state: UserSliceState, action: PayloadAction<string>) => {
    state.errorMessage = action.payload
  },

  /* User Register Reducers */
  setUserRegisterButtonStepValue: (state: UserSliceState, action: PayloadAction<number>) => {
    state.registerForm.step = action.payload
  },
  setUserFormCredentials: (state: UserSliceState, action: PayloadAction<UserCredentials>) => {
    state.registerForm.credentials = action.payload
  },
  resetUserForm: (state: UserSliceState) => {
    state.registerForm = initialState.registerForm
  },
  setUserPersonalDataForm: (state: UserSliceState, action: PayloadAction<any>) => {
    const data = action.payload
    state.registerForm.personalData.firstName = data.firstName
    state.registerForm.personalData.lastName = data.lastName
    state.registerForm.personalData.companyName = data?.companyName
    state.registerForm.personalData.country = data?.country
  },

  /* User Register POST reducers */
  setUserRegisterLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.registerUser.loading = action.payload
  },
  setUserRegisterSuccess: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.registerUser.success = action.payload
  },
  setUserRegisterError: (state: UserSliceState, action: PayloadAction<string>) => {
    state.registerUser.error = action.payload
  },
  setUserRegisterEmail: (state: UserSliceState, action: PayloadAction<string>) => {
    state.registerUser.email = action.payload
  },
  resetUserRegisterState: (state: UserSliceState) => {
    state.registerUser = initialState.registerUser
  },
  resetUserRegisterSuccessState: (state: UserSliceState) => {
    state.registerUser.loading = false
    state.registerUser.success = false
    state.registerUser.error = null
  },

  /* Valida Email Reducers */
  setValidateEmailLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.validateEmail.loading = action.payload
  },
  setValidateEmailSuccess: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.validateEmail.success = action.payload
  },
  setValidateEmailError: (state: UserSliceState, action: PayloadAction<string>) => {
    state.validateEmail.error = action.payload
  },
  resetValidateEmailState: (state: UserSliceState) => {
    state.validateEmail = initialState.validateEmail
  },
  /* Valida Email Reducers */
  setValidateEmailForStockSaleLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.validateEmailForStockSale.loading = action.payload
  },
  setValidateEmailForStockSaleSuccess: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.validateEmailForStockSale.success = action.payload
  },
  setValidateEmailForStockSaleError: (state: UserSliceState, action: PayloadAction<string>) => {
    state.validateEmailForStockSale.error = action.payload
  },
  resetValidateEmailForStockSaleState: (state: UserSliceState) => {
    state.validateEmailForStockSale = initialState.validateEmailForStockSale
  },
  /* Change Password Reducers */
  setChangePasswordLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.changePassword.loading = action.payload
  },
  setChangePasswordSuccess: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.changePassword.success = action.payload
  },
  setChangePasswordError: (state: UserSliceState, action: PayloadAction<string>) => {
    state.changePassword.errorMessage = action.payload
  },
  resetChangePasswordState: (state: UserSliceState) => {
    state.changePassword = initialState.changePassword
  },
  /* Update User Login Reducers */
  setUpdateUserLoginPersonalDataLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.updatePersonalData.loading = action.payload
  },
  setUpdateUserLoginPersonalDataSuccess: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.updatePersonalData.success = action.payload
  },
  setUpdateUserLoginPersonalDataError: (state: UserSliceState, action: PayloadAction<any>) => {
    state.updatePersonalData.error = action.payload
  },
  setUpdateUserLoginPersonalDataNewEmail: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.updatePersonalData.newEmail = action.payload
  },
  resetUserPersonalDataState: (state: UserSliceState) => {
    state.updatePersonalData = initialState.updatePersonalData
  },
  /* Delete Auth User */
  setDeleteAuthUserLoading: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.deleteAuthUser.loading = action.payload
  },
  setDeleteAuthUserSuccess: (state: UserSliceState, action: PayloadAction<boolean>) => {
    state.deleteAuthUser.success = action.payload
  },
  setDeleteAuthUserErrorMessage: (state: UserSliceState, action: PayloadAction<any>) => {
    state.deleteAuthUser.errorMessage = action.payload
  },
  resetDeleteAuthUserState: (state: UserSliceState) => {
    state.deleteAuthUser = initialState.deleteAuthUser
  },
  /* User Subscriptions */
  setUserSubscriptions: (state: UserSliceState, action: PayloadAction<UserSubscription[]>) => {
    state.userSubscriptions = action.payload
  },
  resetUserSubscriptions: (state: UserSliceState) => {
    state.userSubscriptions = []
  },
}

export default reducers
